import { FormGroup } from '@angular/forms';
import { PaysafeForm } from './paysafe-form.interface';

export type PaysafeFormValue = ReturnType<
  FormGroup<PaysafeForm>['getRawValue']
>;
